import apiClient from "./apiClient";

// создаём axios-инстанс
const awardApi = apiClient('');

const userDropsApi = {
    async getUserDrops(page = 1, limit = 10) {
        const response = await awardApi.get('/awards/my', {
            params: { page, limit }
        });

        return response.data;
    },
    
    /**
     * Получить статистику по наградам для создателя промо
     * GET /awards/promo/:promoId/stats
     * Возвращает: { awards: [...], positions: [...] }
     */
    async getPromoAwardsStats(promoId) {
        const response = await awardApi.get(`/awards/promo/${promoId}/stats`);
        return response.data;
    },

    /**
     * Сделать claim (выдача награды)
     * POST /awards/issue
     * @param {number} promoId 
     * @param {number} userId 
     * @param {boolean} referralRetry - второй шанс через реферальную ссылку
     */
    async issue({ promoId, userId, referralRetry = false }) {
        const response = await awardApi.post('/awards/issue', {
            promoId,
            userId,
            referralRetry,
        });
        return response.data;
    },
};

export default userDropsApi;
